export default __webpack_public_path__ + "static/media/comment-emote-angry.0d9d0a21.svg";